import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import A_AU from './comps/A_AU';
import AU2 from './comps/AU2';
import AU3 from './comps/AU3';
import AU4 from './comps/AU4';
import AU5 from './comps/AU5';
import C from './comps/C';
import FootTc from './comps/FootTc';
import G from './comps/G';
import I from './comps/I';
import K from './comps/K';
import N from './comps/N';
import NA3 from './comps/NA3';
import R from './comps/R';
import S from './comps/S';
import Users from './comps/Users';
import styles from './ProductContent.module.scss';

export default function Teaser() {
    const { locale } = useRouter();
    const RenderPageContent = () => {
        if (locale === 'au') {
            return (
                <>
                    <A_AU />
                    {/* <AU1 /> */}
                    <C />
                    <AU2 />
                    <AU3 />
                    <AU4 />
                    <AU5 />
                    <div className="bg-black">
                        <K />
                        <NA3 />
                    </div>
                    <I />
                    <G />
                    <R />
                    <S />
                    <N />
                    <EfSpec className="spec-x" />
                    <Users />
                    <FootTc />
                </>
            );
        }
        return null;
    };
    return (
        <div className={styles.teaser}>
            <RenderPageContent />
        </div>
    );
}
